<div *ngIf="dataForm$ | async"></div>
<form [formGroup]="inputForm">
  <form-row>
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>IBAN</mat-label>
      <input matInput type="text" placeholder="IBAN" formControlName="iban" (paste)="pasteValue($event)" />
      <mat-error *ngIf="inputForm.get('iban').errors">
        {{ errorText }}
      </mat-error>
    </mat-form-field>
  </form-row>
  <p *ngIf="inputForm.get('bic').value">BIC: {{ inputForm.get('bic').value }}</p>
  <p *ngIf="inputForm.get('bankName').value">Bank: {{ inputForm.get('bankName').value }}</p>
</form>
